import {GET_IMAGES_SUCCESS} from "../actions/images";

const initialState = {
  images: {}
};

const images = (state = initialState.images, action) => {
  switch (action.type) {
    case GET_IMAGES_SUCCESS:
      let imagesObj = {};
      
      action.values = action.values.map(v => {
        let keyName = v.url.split('/');
        keyName = keyName[keyName.length - 1].split('.')[0];
        imagesObj[keyName] = v.url;
        return v;
      });
      return imagesObj;
    default:
      return state;
  }
};

export default images;


// WEBPACK FOOTER //
// ./src/reducers/images.js